export const SITE = {
  name: "GoGoAuto Mobile Repair & Service",
  phoneDisplay: "+1 (437) 981-7778",
  phoneRaw: "+14379817778",
  whatsapp: "14379817778",
  email: "gogoautoservices@gmail.com",
  area: "Scarborough & the Greater Toronto Area",
};

export const waLink = (text) =>
  `https://api.whatsapp.com/send?phone=${SITE.whatsapp}&text=${encodeURIComponent(text)}`;

// Haroon's Google review link (Google Business Profile: "GoGoAuto Mobile Repair & Service")
export const REVIEW_LINK = "https://g.page/r/Ced5pWZUbzx1EBM/review";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1756575527484-2839c593ed84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxhdXRvJTIwZGlhZ25vc3RpYyUyMG1lY2hhbmljJTIwZW5naW5lJTIwZGFyayUyMGdhcmFnZSUyMGNhciUyMHJlcGFpcnxlbnwwfHx8fDE3ODg4OTkxMTF8MA&ixlib=rb-4.1.0&q=85",
  diagnostics:
    "https://images.unsplash.com/photo-1706675804644-c8fa831038ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxhdXRvJTIwZGlhZ25vc3RpYyUyMG1lY2hhbmljJTIwZW5naW5lJTIwZGFyayUyMGdhcmFnZSUyMGNhciUyMHJlcGFpcnxlbnwwfHx8fDE3ODg4OTkxMTF8MA&ixlib=rb-4.1.0&q=85",
  brakes:
    "https://images.unsplash.com/photo-1760317890314-e964ffd7e6a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxicmFrZSUyMHJlcGFpcnxlbnwwfHx8fDE3ODg4OTkxMTF8MA&ixlib=rb-4.1.0&q=85",
  undercar:
    "https://images.unsplash.com/photo-1702146713858-8e7d1cc29fe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxicmFrZSUyMHJlcGFpcnxlbnwwfHx8fDE3ODg4OTkxMTF8MA&ixlib=rb-4.1.0&q=85",
  tools:
    "https://images.unsplash.com/photo-1786489623872-2ebdfe51297c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxicmFrZSUyMHJlcGFpcnxlbnwwfHx8fDE3ODg4OTkxMTF8MA&ixlib=rb-4.1.0&q=85",
};

export const PRICING = [
  {
    id: "diagnostics",
    title: "Call-Out & Diagnostics",
    note: "$100 flat call-out covers travel & basic vehicle setup",
    rows: [
      { name: "Mobile Call-Out Fee", price: "$100 flat", detail: "Dispatch charge — travel & basic vehicle setup" },
      { name: "Computer Diagnostic & Scan", price: "$200 total", detail: "Full-system module scan, live data review, diagnostic report ($100 + call-out)" },
      { name: "Electrical / No-Start Diagnostic", price: "$120–$150/hr + call-out", detail: "Circuit isolation, voltage drop tests, parasitic draw checks" },
      { name: "Pre-Purchase Inspection (PPI)", price: "$250 total", detail: "Structural, mechanical, electrical & computer diagnostics ($150 + call-out)" },
    ],
  },
  {
    id: "maintenance",
    title: "Maintenance & Preventative Care",
    note: "Call-out included unless noted",
    rows: [
      { name: "Full Synthetic Oil & Filter Service", price: "$180–$220", detail: "Parts, premium synthetic oil, call-out & health report" },
      { name: "Brake Fluid Flush & Bleed", price: "$160–$190 + parts", detail: "Complete system flush with fresh DOT fluid" },
      { name: "Coolant System Drain & Refill", price: "$170–$210 + parts", detail: "Full coolant exchange & system check" },
      { name: "Cabin & Engine Air Filters", price: "$40–$60 + call-out + parts", detail: "Ideal as an add-on during an oil change" },
    ],
  },
  {
    id: "brakes",
    title: "Brake Services",
    note: "Per axle — labor + call-out included",
    rows: [
      { name: "Brake Pad Replacement", price: "$220–$260 + parts", detail: "Per axle, premium pads installed on-site" },
      { name: "Pad & Rotor Replacement", price: "$280–$340 + parts", detail: "Per axle, pads + rotors with bedding-in" },
      { name: "Single Calliper Replacement", price: "$240–$280 + parts", detail: "Includes fluid bleed" },
    ],
  },
  {
    id: "underhood",
    title: "Common Under-Hood Repairs",
    note: "Labor + call-out included",
    rows: [
      { name: "Battery Replacement", price: "$140–$170 + battery", detail: "Includes installation and registration/reset" },
      { name: "Starter Motor Replacement", price: "$250–$350 + parts", detail: "On-site removal & installation" },
      { name: "Alternator Replacement", price: "$260–$360 + parts", detail: "Charging system tested after install" },
      { name: "Spark Plug Service (4-Cylinder)", price: "$200–$240 + parts", detail: "Gapped & torqued to spec" },
      { name: "Spark Plug Service (6-Cylinder)", price: "$260–$340 + parts", detail: "Depends on intake manifold access" },
      { name: "Serpentine Belt Replacement", price: "$180–$220 + parts", detail: "Belt & tensioner inspection included" },
    ],
  },
];

export const SERVICE_OPTIONS = [
  "Computer Diagnostic & Scan",
  "Electrical / No-Start Diagnostic",
  "Pre-Purchase Inspection",
  "Synthetic Oil & Filter Service",
  "Brake Pads / Rotors",
  "Battery Replacement",
  "Starter / Alternator",
  "Spark Plugs / Belts",
  "Not sure — diagnose it for me",
];

export const TIME_SLOTS = [
  "Morning (8–11 AM)",
  "Midday (11 AM–2 PM)",
  "Afternoon (2–5 PM)",
  "Evening (5–8 PM)",
];

export const REVIEWS = [
  {
    name: "Marco S.",
    area: "Scarborough",
    text: "Diagnosed an elusive parasitic battery drain on my Audi right in my driveway. Saved me hundreds versus dealership towing.",
  },
  {
    name: "Elena R.",
    area: "North York",
    text: "Brake replacement done while I worked from home. Professional, polite, and completely transparent about pricing.",
  },
  {
    name: "David K.",
    area: "Markham",
    text: "The pre-purchase inspection saved me from buying a car with blown head gaskets. True 310S master tech precision.",
  },
];

export const SERVICE_AREAS = [
  "Scarborough",
  "North York",
  "Markham",
  "Pickering",
  "Ajax",
  "Etobicoke",
  "Downtown Toronto",
];

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const AREAS = {
  scarborough: {
    name: "Scarborough",
    hoods: "Agincourt · Birch Cliff · Guildwood · Malvern · Woburn · Cliffside",
    copy1: "Scarborough is our home base — GoGoAuto Mobile Repair & Service was built here, and most of our calls are in the 416 east end. From Agincourt to Guildwood, a licensed 310S master technician arrives at your driveway with dealer-level diagnostic equipment, ready for everything from no-start electrical faults to full brake jobs.",
    copy2: "Skip the tow truck and the waiting room: we service vehicles in driveways, condo visitor parking, and office lots across Scarborough, with upfront pricing approved before any work begins.",
    copy3: "Scarborough drivers deal with it all — 401 commutes, Kingston Road traffic, and January cold snaps that kill weak batteries overnight. We stock the common parts for the vehicles we see most in the east end, from Honda and Toyota daily drivers to family SUVs, so most repairs finish in a single visit. Students at U of T Scarborough and Centennial College get the same upfront pricing as everyone else: you approve the quote, we do the work, and you drive away with a written health report for your records.",
  },
  "north-york": {
    name: "North York",
    hoods: "Willowdale · Don Mills · Downsview · Jane & Finch · York Mills",
    copy1: "North York drivers skip the shop entirely — our mobile service unit covers Willowdale, Don Mills, Downsview, and Jane & Finch with on-site diagnostics, brakes, batteries, and routine maintenance.",
    copy2: "Book a morning window before work and the repair is done before lunch — every price confirmed upfront before we start.",
    copy3: "North York is condo country, and we know the drill — visitor parking, underground clearance limits, and tight schedules. Our mobile setup works where tow trucks can't reach. Commuters running the 401, 404, or DVP book evening windows so the car is ready for the morning rush. Multi-car households along Sheppard and Finch can book back-to-back slots in a single visit and pay just one call-out fee for the whole driveway.",
  },
  markham: {
    name: "Markham",
    hoods: "Unionville · Milliken · Cornell · Box Grove · Berczy",
    copy1: "From Unionville to Cornell and Box Grove, Markham residents get master-technician service without crossing Steeles. Pre-purchase inspections are a local favourite — have us check a used car at the seller's curb before you hand over a deposit.",
    copy2: "Every visit includes a full health report and honest advice on what needs attention now versus later.",
    copy3: "Markham's growth means new driveways appearing every month from Berczy to Wismer — and plenty of used-car purchases that deserve a proper inspection before money changes hands. Our pre-purchase inspections cover structure, mechanics, electronics, and a full computer scan, performed right at the seller's curb. Highway 7 and Woodbine commuters rely on us for brakes, batteries, and seasonal maintenance without losing half a day sitting in a repair shop lounge.",
  },
  pickering: {
    name: "Pickering",
    hoods: "Liverpool · Brock Ridge · Seaton · Village East",
    copy1: "Pickering is fully covered — Liverpool, Brock Ridge, Seaton and everywhere between. Our mobile unit handles brakes, alternators, starters, and full computer diagnostics right in your driveway.",
    copy2: "No towing fees into the city, no shop markups — just licensed 310S work at your door.",
    copy3: "From Frenchman's Bay to the new Seaton developments, Pickering vehicles rack up serious kilometres on the 401 and Brock Road. That means brakes, suspension, and fluids on a real maintenance schedule — not a breakdown on the way to the GO station. We bring the shop to your driveway, and every service ends with a health report so you can plan maintenance around your commute instead of reacting to surprises on the highway.",
  },
  ajax: {
    name: "Ajax",
    hoods: "South Ajax · Westney Heights · Downtown Ajax · Audley",
    copy1: "Ajax commuters count on reliable cars, and GoGo keeps them that way with driveway service across South Ajax, Westney Heights, and the downtown core. Battery died before the GO train? We test, replace, and register it on the spot.",
    copy2: "Same straightforward pricing as everywhere we serve — you approve the quote before we start.",
    copy3: "Ajax is family-SUV territory, and family vehicles can't afford surprise breakdowns between school runs and weekend hockey at the Audley Recreation Centre. We handle the maintenance that keeps them dependable — synthetic oil services, brake fluid flushes, coolant exchanges, and battery testing before winter hits. Two cars in the driveway? Book both in one visit and pay only a single call-out fee for the pair.",
  },
  etobicoke: {
    name: "Etobicoke",
    hoods: "Mimico · Long Branch · Rexdale · Humber Bay · Alderwood",
    copy1: "Etobicoke service without the shop trip — Mimico, Long Branch, Rexdale, and Humber Bay all covered. Our 310S master technician brings OEM-grade scanners and a fully stocked mobile unit to your street.",
    copy2: "From mysterious check-engine lights to brake jobs done while you work from home.",
    copy3: "Etobicoke's mix of lakeside condos and post-war streets keeps us busy year-round — road salt and lake-effect moisture are hard on brakes, wiring, and underbodies out here. Our mobile unit is set up for tight downtown-style parking and narrow driveways alike. Whether you're near the airport corridor on Dixon Road or down by the Humber Bay shores, the same licensed 310S master technician shows up with the same honest, upfront price list.",
  },
  toronto: {
    name: "Downtown Toronto",
    hoods: "Liberty Village · King West · East York · The Beaches · Leslieville",
    copy1: "Downtown Toronto — condo parking, tight schedules, and no room for downtime. We service vehicles in visitor lots and underground garages with clearance across Liberty Village, King West, East York, and the Beaches.",
    copy2: "Text us your location on WhatsApp and we'll confirm access and a time window fast.",
    copy3: "Downtown car ownership is different — street parking, condo garages, and zero time to sit in a shop across town. We coordinate access to visitor and underground parking, work cleanly and quietly, and leave no trace behind when we're done. From Liberty Village condos to Beaches driveways, downtown drivers get dealership-grade diagnostics and repairs without ever arranging a ride home from a garage or paying downtown shop rates.",
  },
};
